import PropTypes from "prop-types"

export const QuotationType = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  course: PropTypes.number,
}
